import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Button } from '@components';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import { boPhanCreateAction } from '@app/store/reducers/boPhan';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { toast } from 'react-toastify';
import { messageToast } from '@app/utils/define';

const BoPhanAdd = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [maBoPhan, setMaBoPhan] = useState('');
    const [tenBoPhan, setTenBoPhan] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const model = { maBoPhan, tenBoPhan };

        try {
            setIsLoading(true);
            await dispatch(boPhanCreateAction(model)).unwrap();

            toast.success(messageToast.messageToastCreateSuccess);
            history.push(URI_INTERNAL.BOPHAN_PATH);
        } catch (err) {
            console.error('Thêm bộ phận lỗi:', err);

            const msg =
                (err && err.message) ||
                (typeof err === 'string' ? err : '') ||
                (err && err.title) ||
                '';

            toast.error(
                msg
                    ? `${messageToast.messageToastCreateError}: ${msg}`
                    : messageToast.messageToastCreateError
            );
            setIsLoading(false);
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm bộ phận</Card.Header>
            <Card.Body>
                <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Mã bộ phận
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Mã bộ phận"
                                type="text"
                                value={maBoPhan}
                                onChange={(e) => setMaBoPhan(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Tên bộ phận
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Tên bộ phận"
                                type="text"
                                value={tenBoPhan}
                                onChange={(e) => setTenBoPhan(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col md={{ span: 10, offset: 2 }}>
                            <ButtonGroup>
                                <Button
                                    type="submit"
                                    theme="primary"
                                    disabled={isLoading}
                                >
                                    Lưu
                                </Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button
                                    type="button"
                                    theme="secondary"
                                    onClick={() =>
                                        history.push(URI_INTERNAL.BOPHAN_PATH)
                                    }
                                    disabled={isLoading}
                                >
                                    Hủy
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Form.Group>
                </Form>

                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default BoPhanAdd;
